window.app_models.property = {
    "id":null,
    "date_given":null,
    "miles_from_loss":null,
    "furnished":null,
    "unit":null,
    "elevator":null,
    "sqft":null,
    "den":null,
    "baths":null,
    "floor":null,
    "beds":null,
    "amenity_id":null,
    "vacate_notice_id":null,
    "unit_type_id":1,
    "property_type_id":1,
    "property_status_id":1,
    "rejection_note":null,
    "placement_id":null,
    label: null,
    "budget":window.app_models.budget,
    "address":window.app_models.address,
    "property_amenities":[
        window.app_models.option
    ],
    "amenities":window.app_models.amenities,
    "landlord":window.app_models.contact,
    "property_contacts":[
        window.app_models.property_contact
    ],
    "unit_details":[
        window.app_models.unit_detail
    ],
    "lease_detail": window.app_models.lease_detail,
    "vacate_notice":window.app_models.vacate_notice,
    "unit_type":window.app_models.option,
    "property_type":window.app_models.option,
    "unit_type":window.app_models.option,
    "property_type":window.app_models.option,
    "property_status":window.app_models.option
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/property.js